import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription, switchMap, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { BrokerService } from 'src/app/services/broker.services';
import { TemaService } from 'src/app/services/tema.services';
import { SseService } from 'src/app/services/SseService';
import { OAuthService } from 'src/app/services/oauth.service';
import { BrokerAdapterFactory } from 'src/app/services/broker-adapter-factory.service';
import { motivoRechazoMetaApi, translateMetaApiHttpError } from 'src/app/services/meta-api-error-messages';
import { BrokerTimeService } from 'src/app/services/broker-time.service';
import { OrdenesSyncService } from 'src/app/services/ordenes-sync.service';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { EditarOrdenComponent } from '../../broker/editar-orden/editar-orden.component';
import { ColaOrdenesService } from 'src/app/services/cola-ordenes.service';
import { SlTpBrokerService } from 'src/app/services/sltp-broker.service';
import { formatHoraCotizacion, formatFechaHoraCotizacion } from '../cartera-utils';

/** Estados IBKR / MetaAPI de orden ejecutada */
const ESTADOS_FILLED = ['Filled', 'ORDER_STATE_FILLED'];

/** Lista de órdenes enviadas al broker (pestaña Posiciones Cartera y Control Operativa). */
@Component({
  selector: 'app-lista-ordenes',
  templateUrl: './lista-ordenes.component.html',
  styleUrl: './lista-ordenes.component.scss'
})
export class ListaOrdenesComponent implements OnInit, OnDestroy {
  /** Alto del viewport; por defecto el de .wrapperBroker. */
  @Input() alto: string | null = null;
  /** Al cargar la cartera, consultar en IBKR el estado de las órdenes pendientes (solo una instancia debería hacerlo). */
  @Input() consultarEstadoBroker = true;
  /** En Control Operativa: marca las STP cuyo SL dinámico ya subió sobre el inicial. */
  @Input() controlOperativa = false;
  /** Mostrar arriba las órdenes que esperan en la cola de envío (aún no enviadas al broker). */
  @Input() mostrarCola = false;
  /** Filas de la cola de envío de esta cuenta (enCola: true). */
  private colaPendiente: any[] = [];
  private colaCruda: any[] = [];
  /** Última lista recibida de broker/listaordenes. */
  private ordenesBroker: any[] = [];
  /** Operación por orderidsalidastp (en MetaAPI es el positionId, igual que el orderId de la orden). */
  private operacionPorStp = new Map<string, any>();
  /** Órdenes recibidas de broker/listaordenes en cada carga. */
  @Output() ordenesCargadas = new EventEmitter<any[]>();

  @ViewChild('ordenesView', { static: false }) operacionesViewport!: CdkVirtualScrollViewport;

  colPanelOpen = false;
  /** Filtros flotantes de pares (órdenes Filled agrupadas por ID): ambos apagados = se muestran todas. */
  verAbiertos = false;
  verCerrados = false;
  public isDark: boolean = false;
  theme: string | string[] | undefined;
  public ListaOrdenes: CdkTableVirtualScrollDataSource<any>;
  public brokOptimaWallet: any;
  private brokerOffsetMin: number | null = null;
  public filaSeleccionada: any;
  filasSeleccionadas: any[] = [];
  public ordenesOriginal: any;
  public licencia: string;

  private subscriptions = new Subscription();

  tableColumnsOrdenes: TableColmuns[] = [
    { id: 'index', name: '#', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'orderId', name: 'Id Orden', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'ticker', name: 'Compañia', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'companyName', name: 'ID', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'cartera', name: 'Cartera', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'modelo', name: 'Subcartera', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'fechaRegistro', name: 'Fecha Envio', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'lastExecutionTime_r', name: 'Ejecucion Broker', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'fechaActualizacion', name: 'Fecha Registro', isShow: false, isDate: false, isNumber: false, isString: true },

    //{ id: 'lastTime', name: 'Hora', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'orderType', name: 'Tipo Orden', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'status', name: 'Estado', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'side', name: 'Buy/Sell', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'price', name: 'Precio Orden', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'avgPrice', name: 'Precio', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'quantity', name: 'N° Acciones', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'remainingQuantity', name: 'N° Acciones Pendientes', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'filledQuantity', name: 'N° Acciones Ejecutadas', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'origen', name: 'Origen', isShow: true, isDate: false, isNumber: false, isString: true },
  ]

  displayedColumnsOrdenes: string[] = ['index', 'orderId', 'ticker', 'lastExecutionTime_r', /**'lastTime',**/ 'orderType', 'status', 'side',
    'price', 'avgPrice', 'quantity', 'filledQuantity', 'remainingQuantity', 'origen'];

  constructor(private _broker: BrokerService,
    private temaService: TemaService,
    private brokerTimeService: BrokerTimeService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private _cookieService: CookieService,
    private _sseService: SseService,
    public oauthService: OAuthService,
    private brokerAdapterFactory: BrokerAdapterFactory,
    private ordenesSync: OrdenesSyncService,
    private colaOrdenesService: ColaOrdenesService,
    public sltp: SlTpBrokerService,
    private cdr: ChangeDetectorRef) {
    this.ListaOrdenes = new CdkTableVirtualScrollDataSource<any>();
    this.licencia = this._cookieService.get('auth_token');
  }

  ngOnInit(): void {
    if (this.controlOperativa) {
      this.subscriptions.add(this.colaOrdenesService.operaciones$.subscribe(ops => {
        this.operacionPorStp.clear();
        (ops || []).forEach((op: any) => {
          if (op.orderidsalidastp && op.orderidsalidastp != '0') this.operacionPorStp.set(String(op.orderidsalidastp), op);
        });
      }));
    }
    this.subscriptions.add(this._broker.valBrokOptimaWallet$.subscribe({
      next: (data: any) => {
        if (data.nombre) {
          this.brokOptimaWallet = data;
          this.actualizarCola();
          this.listOrdenes(this.brokOptimaWallet.idcartera, this.consultarEstadoBroker ? 1 : 0);
          if (this.brokOptimaWallet.tipoBroker === 'METAAPI') {
            const accountId = this.brokOptimaWallet.metaApiAccountId || this.brokOptimaWallet.nombre;
            this.brokerTimeService.getOffsetMinutes(accountId).subscribe(offsetMin => this.brokerOffsetMin = offsetMin);
          } else {
            this.brokerOffsetMin = null;
          }
        }
      }
    }));
    this.subscriptions.add(this._broker.valcargarListas$.subscribe({
      next: (data: any) => {
        if (data && this.brokOptimaWallet) {
          this._broker.updatecargarListas(false);
          this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
        }
      }
    }));
    if (this.mostrarCola) {
      this.subscriptions.add(this.colaOrdenesService.colaOrdenes$.subscribe(cola => {
        this.colaCruda = cola || [];
        this.actualizarCola();
      }));
    }
    // Órdenes canceladas desde /broker-operations (otra pestaña): recargar sin esperar al polling
    this.subscriptions.add(this.ordenesSync.cambios$.subscribe(idcartera => {
      if (this.brokOptimaWallet?.idcartera && String(this.brokOptimaWallet.idcartera) === idcartera) {
        this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
      }
    }));
    this.subscriptions.add(this.temaService.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /** Vuelve a pedir la lista de órdenes de la cartera actual. */
  recargar() {
    if (this.brokOptimaWallet?.idcartera) {
      this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
    }
  }

  /** El viewport virtual mide 0 mientras la pestaña está oculta: recalcular al mostrarse. */
  actualizarViewport() {
    if (this.operacionesViewport) {
      this.operacionesViewport.checkViewportSize();
      this.cdr.detectChanges();
    }
  }

  /** Convierte la cola de envío de esta cuenta en filas de la tabla y refresca. */
  private actualizarCola() {
    if (!this.mostrarCola) return;
    const cuenta = this.brokOptimaWallet?.nombre;
    this.colaPendiente = cuenta ? this.colaCruda
      .map(item => item?.orders?.[0])
      .filter(o => o && o.acctId === cuenta)
      .map(o => ({
        enCola: true, orderId: '—', ticker: o.ticker, companyName: o.ticker,
        orderType: o.orderType, side: o.side, price: o.price, quantity: o.quantity,
        remainingQuantity: o.quantity, filledQuantity: 0, status: 'En cola', cOID: o.cOID
      })) : [];
    this.refrescarTabla();
  }

  /** Cola + órdenes del broker, sin aplicar los filtros de la tabla. */
  private get todasOrdenes(): any[] {
    return [...this.colaPendiente, ...this.ordenesBroker];
  }

  refrescarTabla() {
    this.ListaOrdenes.data = this.renumerarOrdenes(this.filtrarOrdenes(this.todasOrdenes));
    if (this.operacionesViewport) { this.operacionesViewport.checkViewportSize(); }
  }

  /**
   * Pares por ID (companyName = isooper), clasificados con sus órdenes Filled:
   * cerrado si hay BUY y SELL Filled, abierto si solo un lado. Se muestra el grupo completo del ID.
   */
  private filtrarOrdenes(data: any[]): any[] {
    if (!this.verAbiertos && !this.verCerrados) return data;
    const grupos = new Map<string, any[]>();
    data.filter(o => !o.enCola && o.companyName).forEach(o => {
      const grupo = grupos.get(o.companyName);
      grupo ? grupo.push(o) : grupos.set(o.companyName, [o]);
    });
    const resultado: any[] = [];
    grupos.forEach(ordenes => {
      const lados = new Set(ordenes.filter(o => ESTADOS_FILLED.includes(o.status)).map(o => String(o.side ?? '').toUpperCase()));
      if (!lados.size) return;
      const cerrado = lados.has('BUY') && lados.has('SELL');
      if (cerrado ? this.verCerrados : this.verAbiertos) resultado.push(...ordenes);
    });
    return resultado;
  }

  /** Las órdenes en cola aún no existen en el broker: no se cancelan, editan ni eliminan. */
  private avisoEnCola(): boolean {
    if (!this.filaSeleccionada?.enCola) return false;
    this.toastr.info('Orden en cola, aún no enviada al broker', 'Órdenes');
    return true;
  }

  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }

  toggleColumnVisibilityOrdenes(id: any) {
    const column = this.tableColumnsOrdenes.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumnsOrdenes = this.tableColumnsOrdenes.filter(col => col.isShow).map(col => col.id);
    }
  }

  isSelected(row: any): boolean {
    return this.filasSeleccionadas.includes(row);
  }

  selectRowCartera(row: any) {
    const index = this.filasSeleccionadas.findIndex(r => r === row);
    if (index > -1) {
      this.filasSeleccionadas.splice(index, 1);
    } else {
      this.filasSeleccionadas.push(row);
    }
  }

  /** Operación de la STP si su SL dinámico ya subió sobre el inicial (pendiente de "Actualizar Stop Loss"). */
  slSubido(orden: any): any {
    const op = this.operacionPorStp.get(String(orden?.orderId));
    return op && op.stoploss > 0 && op.stoplossinicial !== undefined && op.stoplossinicial < op.stoploss ? op : null;
  }

  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
  }

  async consultarordenesalbroker() {
    console.log("consultarordenesalbroker " + this.todasOrdenes.length + " filas");

    // MetaAPI: order status is already synced via the polling in broker.component,
    // so there is no need to call the IBKR-only /iserver/account/order/status endpoint.
    if (this.brokOptimaWallet?.tipoBroker === 'METAAPI') {
      return;
    }

    let data = this.todasOrdenes;
    for (let i = 0; i < data.length; i++) {
      if (data[i].enCola || data[i].status === 'Filled' || data[i].status === 'Cancelled' || data[i].status === 'Inactive' || data[i].status === 'Sincro') {
        console.log("ESTA ORDEN NO SE actualizar estado: ");
      } else {
        this.actualizarEstadoOrden(data[i].orderId).subscribe({
          next: (response: any) => {
            console.log("Estado de orden actualizado:", response);
            if (response.status) {
              this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
            }
          },
          error: (error: any) => {
            console.error("Error al actualizar el estado de la orden:", error);
          }
        });
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }

  listOrdenes(idCartera: any, accion: number) {
    let url = 'broker/listaordenes';
    let licencia = this._cookieService.get('auth_token');
    let jsonData = { idcartera: idCartera, tipoBroker: this.brokOptimaWallet.tipoBroker };
    this._sseService.apiPostNew(url, jsonData, licencia).subscribe({
      next: (data: any[]) => {
        this.ordenesBroker = data;
        this.refrescarTabla();
        localStorage.setItem('listaordenes'+this.brokOptimaWallet.nombre, JSON.stringify(data));

        this.ordenesCargadas.emit(data);
        this.ordenesOriginal = data;
        if (accion == 1) this.consultarordenesalbroker();
      }
    });

  }
  private actualizarEstadoOrden(orderId: string): Observable<any> {
    console.log("actualizarEstadoOrden orderId: ", orderId);
    return this.oauthService.apiGetIbrk('/iserver/account/order/status/' + orderId).pipe(
      switchMap((data: any) => {
        console.log("Estado de orden:", data);
        return this._sseService.apiPostNew('broker/actualizarOrdenEstado', data, this.licencia);
      }),
      catchError((err: any) => {
        const httpStatus = err?.status;
        const bodyStatus = err?.error?.statusCode;
        const bodyMsg: string = err?.error?.error ?? '';
        if ((httpStatus === 503 || bodyStatus === 503)) {
          console.warn(`actualizarEstadoOrden: servicio no disponible para orden ${orderId}. Body: ${bodyMsg}`);
          if (bodyMsg.includes('is not found')) {
            console.warn(`actualizarEstadoOrden: orden ${orderId} no encontrada en broker. Body: ${bodyMsg}`);
            this._sseService.apiPostNew('broker/marcarOrdenInexistente', { order_id: orderId }, this.licencia).subscribe({
              next: (response: any) => {
                console.log(`Orden ${orderId} marcada como inactiva:`, response);
                this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
              },
              error: (error: any) => {
                console.error(`Error al marcar orden ${orderId} como inactiva:`, error);
              }
            });
//            let data = {
  //            order_id: orderId,
    //          order_status: 'Innactive' // orderId  .... order_id 
      //      };
        //    return this._sseService.apiPostNew('broker/actualizarOrdenEstado', data, this.licencia);
          }
        }
        console.error(`actualizarEstadoOrden: error inesperado para orden ${orderId}`, err);
        return of({ status: false, skipped: true, reason: 'error' });
      })
    );
  }
  /** MetaTrader con Algo Trading desactivado: aviso y no se inicia el flujo. */
  CancelarTodasOrden() {
    this.brokerAdapterFactory.puedeOperar(this.brokOptimaWallet?.tipoBroker).subscribe(ok => { if (ok) this.CancelarTodasOrdenConfirmado(); });
  }

  private CancelarTodasOrdenConfirmado() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '250px',
      panelClass: this.theme,
      data: {
        msj: 'Esta Seguro de Cancelar todas las Ordenes'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        // ListaOrdenes
        this.cancelarOrdenesConRetraso(0);
      }
    });
  }

  // Método para cancelar órdenes con retraso entre cada una
  cancelarOrdenesConRetraso(index: number) {
    const ordenes = this.todasOrdenes;
    if (index >= ordenes.length) {
      // Todas las órdenes han sido procesadas
      this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
      return;
    }

    this.filaSeleccionada = ordenes[index];
    console.log("ORDEN A CANCELAR: ", this.filaSeleccionada);

    if (this.filaSeleccionada.enCola || this.filaSeleccionada.status == 'Filled' || this.filaSeleccionada.status == 'Canceled' ||
      this.filaSeleccionada.status == 'Inactive' || this.filaSeleccionada.status == 'Sincro') {
      // Si la orden no se puede cancelar, pasar a la siguiente
      setTimeout(() => {
        this.cancelarOrdenesConRetraso(index + 1);
      }, 1000);
      return;
    }

    if (this.filaSeleccionada.orderId == undefined || this.filaSeleccionada.orderId == null) {
      console.log("ORDEN NO TIENE ID");
      setTimeout(() => {
        this.cancelarOrdenesConRetraso(index + 1);
      }, 1000);
      return;
    }

    // MetaAPI path
    if (this.brokOptimaWallet?.tipoBroker === 'METAAPI') {
      const accountId = this.brokOptimaWallet.metaApiAccountId || this.brokOptimaWallet.nombre;
      const adapter = this.brokerAdapterFactory.getAdapter(this.brokOptimaWallet);
      adapter.cancelOrder(accountId, String(this.filaSeleccionada.orderId)).subscribe({
        next: () => setTimeout(() => this.cancelarOrdenesConRetraso(index + 1), 500),
        error: () => setTimeout(() => this.cancelarOrdenesConRetraso(index + 1), 500)
      });
      return;
    }
    // Obtener el estado actual de la orden
    this.oauthService.apiGetIbrk('/iserver/account/order/status/' + this.filaSeleccionada.orderId).subscribe({
      next: (data: any) => {
        console.log(data);
        this._sseService.apiPostNew('broker/actualizarOrdenEstado', data, this.licencia).subscribe({
          next: (data: any) => {
            this.oauthService.apiDeleteIbrk('/iserver/account/' + this.brokOptimaWallet.nombre + '/order/' + this.filaSeleccionada.orderId).subscribe({
              next: (data: any) => {
                console.log("RESPUESTA DEL DELETE: ", data);
                this.actualizarEstadoOrden(this.filaSeleccionada.orderId).subscribe({
                  next: () => setTimeout(() => this.cancelarOrdenesConRetraso(index + 1), 1000),
                  error: () => setTimeout(() => this.cancelarOrdenesConRetraso(index + 1), 1000)
                });
              },
              error: () => {
                setTimeout(() => {
                  this.cancelarOrdenesConRetraso(index + 1);
                }, 1000);
              }
            });
          },
          error: () => {
            setTimeout(() => {
              this.cancelarOrdenesConRetraso(index + 1);
            }, 1000);
          }
        });
      },
      error: () => {
        setTimeout(() => {
          this.cancelarOrdenesConRetraso(index + 1);
        }, 1000);
      }
    });
  }

  /** MetaTrader con Algo Trading desactivado: aviso y no se inicia el flujo. */
  CancelarOrden() {
    if (this.filaSeleccionada?.enCola) {
      const fila = this.filaSeleccionada;
      this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: { msj: 'Esta Seguro de Cancelar la orden en cola de ' + fila.ticker }
      }).afterClosed().subscribe(result => {
        if (result) this.colaOrdenesService.solicitarCancelacion(fila.cOID);
      });
      return;
    }
    this.brokerAdapterFactory.puedeOperar(this.brokOptimaWallet?.tipoBroker).subscribe(ok => { if (ok) this.CancelarOrdenConfirmado(); });
  }

  private CancelarOrdenConfirmado() {
    console.log("CancelarOrden ", this.filaSeleccionada);
    if (this.filaSeleccionada.status == 'Filled' || this.filaSeleccionada.status == 'Canceled' || this.filaSeleccionada.status == 'Inactive' || this.filaSeleccionada.status == 'Sincro') {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: {
          msj: 'No se Pueden Cancelar Ordenes en estado : ' + this.filaSeleccionada.status
        }
      });
    } else {

      if (this.filaSeleccionada.orderId == undefined || this.filaSeleccionada.orderId == null) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '380px',
          height: '250px',
          panelClass: this.theme,
          data: {
            msj: 'Esta orden no se puede cancelar, se debe eliminar'
          }
        });
      } else {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '380px',
          height: '250px',
          panelClass: this.theme,
          data: {
            msj: 'Esta Seguro de Cancelar la Orden ' + this.filaSeleccionada.orderId
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('El diálogo se cerró');
          if (result) {
            if (this.brokOptimaWallet?.tipoBroker === 'METAAPI') {
              const accountId = this.brokOptimaWallet.metaApiAccountId || this.brokOptimaWallet.nombre;
              this.brokerAdapterFactory.getAdapter(this.brokOptimaWallet)
                .cancelOrder(accountId, String(this.filaSeleccionada.orderId)).subscribe({
                  next: (res: any) => {
                    const rechazo = motivoRechazoMetaApi(res);
                    if (rechazo) {
                      this.toastr.error('MetaAPI error: ' + rechazo, 'MetaAPI', { timeOut: 30000 });
                      return;
                    }
                    this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
                    this._sseService.apiPostNew('metaapi/cancelarOrden', { order_id: Number(this.filaSeleccionada.orderId) }, this.licencia).subscribe({
                      next: (response: any) => {
                        console.log(`Orden ${this.filaSeleccionada.orderId} cancelada en MetaAPI:`, response);
                      },
                      error: (error: any) => {
                        console.error(`Error al cancelar orden ${this.filaSeleccionada.orderId} en MetaAPI:`, error);
                      }
                    });
                  },
                  error: (err: any) => {
                    console.error('MetaAPI cancel order error', err);
                    const msg = err?.error?.message ?? err?.message ?? 'unknown';
                    const errorClass = err?.error?.error;
                    this.toastr.error('MetaAPI error: ' + translateMetaApiHttpError(errorClass, msg), 'MetaAPI', { timeOut: 30000 });
                  }
                });
            } else {
              this.oauthService.apiGetIbrk('/iserver/account/order/status/' + this.filaSeleccionada.orderId).subscribe({
                next: (data: any) => {
                  console.log(data);
                  this._sseService.apiPostNew('broker/actualizarOrdenEstado', data, this.licencia).subscribe({
                    next: (data: any) => {
                      if (data.status) {
                        this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
                      }
                    }
                  });
                }
              });
              this.oauthService.apiDeleteIbrk('/iserver/account/' + this.brokOptimaWallet.nombre + '/order/' + this.filaSeleccionada.orderId).subscribe({
                next: (data: any) => {
                  console.log("RESPUESTA  DEL DELETE: ", data);
                  this.actualizarEstadoOrden(this.filaSeleccionada.orderId).subscribe({
                    next: (finalData: any) => {
                      if (finalData.status) {
                        this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
                      }
                    }
                  });
                },
              });
            }
          } else {
            console.log('La acción fue cancelada');
          }
        });
      }
    }
  }

  editarOrden() {
    console.log("editarOrden ", this.filaSeleccionada);
    if (this.avisoEnCola()) return;
    if (this.filaSeleccionada.status == 'Filled' || this.filaSeleccionada.status == 'Canceled' || this.filaSeleccionada.status == 'Inactive' || this.filaSeleccionada.status == 'Sincro') {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: {
          msj: 'No se Pueden Editar Ordenes en estado' + this.filaSeleccionada.status
        }
      });
    } else {
      const dialogRef = this.dialog.open(EditarOrdenComponent, {
        width: '400px',
        maxHeight: '90vh',
        panelClass: this.theme,
        data: {
          orden: this.filaSeleccionada,
          wallet: this.brokOptimaWallet,
          tipoBroker: this.brokOptimaWallet?.tipoBroker ?? 'IBKR',
          metaApiAccountId: this.brokOptimaWallet?.metaApiAccountId ?? ''
        }
      });
    }
  }

  EliminarOrden() {
    console.log("Eliminar Orden ", this.filaSeleccionada);
    if (this.avisoEnCola()) return;
    if (this.filaSeleccionada.status === null || this.filaSeleccionada.status === '' || this.filaSeleccionada.status === 'Filled' || this.filaSeleccionada.status === 'Inactive' || this.filaSeleccionada.status === 'Cancelled' || this.filaSeleccionada.status === 'Sincro') {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: {
          msj: 'Esta Seguro de Eliminar la Orden ' + this.filaSeleccionada.idorden
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('El diálogo se cerró');
        if (result) {
          let url = 'broker/eliminarOrden/' + this.filaSeleccionada.idorden;
          this._sseService.apiDelete(url, this.licencia).subscribe({
            next: (data: any) => {
              console.log("RESPUESTA  DEL DELETE: ", data);
              this.listOrdenes(this.brokOptimaWallet.idcartera, 0);
            }
          });
        } else {
          console.log('La acción fue cancelada');
        }
      });
    } else {
      this.toastr.error('No se puede eliminar la orden con estado: ' + this.filaSeleccionada.status + ' cancele la orden si la tiene pendiente.', 'Error', { timeOut: 10000, positionClass: 'toast-top-center' });
    }
  }


  sortByTickerAsc(dataArray: any[]): any[] {
    return dataArray.sort((a, b) => {
      return a.ticker.localeCompare(b.ticker);
    });
  }

  sortByOrigstatus(dataArray: any[]): any[] {
    return dataArray.sort((a, b) => {
      return a.status.localeCompare(b.status);
    });
  }

  sortByFechaHora(dataArray: any[]): any[] {
    return dataArray.sort((a, b) => {
      const dateA = new Date(a.fechahora).getTime();
      const dateB = new Date(b.fechahora).getTime();
      return dateB - dateA;
    });
  }

  /** Asigna el número de fila ("#") según el orden final de visualización. */
  private renumerarOrdenes(data: any[]): any[] {
    data.forEach((item, i) => item.index = i + 1);
    return data;
  }

  orderBy(campo: string) {
    let temporal = this.ListaOrdenes.data
    if (campo == 'lastExecutionTime_r') {
      this.ListaOrdenes = new CdkTableVirtualScrollDataSource(this.renumerarOrdenes(this.sortByFechaHora(temporal)));
    } else if (campo == 'status') {
      this.ListaOrdenes = new CdkTableVirtualScrollDataSource(this.renumerarOrdenes(this.sortByOrigstatus(temporal)));
    } else if (campo == 'ticker') {
      this.ListaOrdenes = new CdkTableVirtualScrollDataSource(this.renumerarOrdenes(this.sortByTickerAsc(temporal)));
    }
    this.actualizarViewport();
  }

  formatHoraCotizacion(timestamp: number): string {
    return formatHoraCotizacion(timestamp, this.brokOptimaWallet, this.brokerOffsetMin, this.datePipe, this.brokerTimeService);
  }

  formatFechaHoraCotizacion(timestamp: number): string {
    return formatFechaHoraCotizacion(timestamp, this.brokOptimaWallet, this.brokerOffsetMin, this.datePipe, this.brokerTimeService);
  }
}
